
/////////////////////////////// Payment information Add/remove Card  /////////////////////////////////////


function openCardModal() {
    const modal = document.getElementById('cardModal');
    if (modal) {
      modal.classList.remove('hidden');
    }
  }
  
  function closeCardModal() {
    const modal = document.getElementById('cardModal');
    if (modal) {
      modal.classList.add('hidden');
    }
  }
  
  
  function saveNewCard() {
    const cardholder = document.getElementById('cardholder').value.trim();
    const cardnumber = document.getElementById('cardnumber').value.trim();
    const expirydate = document.getElementById('expirydate').value.trim();
    const cvvcode = document.getElementById('cvvcode').value.trim();
    const billingaddress = document.getElementById('billingaddress').value.trim();
    
    if (cardholder && cardnumber && expirydate && cvvcode && billingaddress) {
      const paymentInfo = document.getElementById('payment-info');
  
      const newCardHTML = `
      <div class="visa-card-item relative w-80 h-48 rounded-xl shadow-lg bg-gradient-to-r from-blue-700 to-blue-500 text-white p-4 flex flex-col justify-between">
        
        <!-- Remove button -->
        <button onclick="removeThisCard(this)" class="absolute bottom-2 right-2 text-sm text-white bg-red-500 hover:bg-red-600 px-2 py-1 rounded shadow">
          🗑 Remove
        </button>
  
    
        <!-- Card Brand -->
        <div class="flex justify-between items-center">
          <div class="text-xs uppercase tracking-widest">Visa Card</div>
          <img src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg" alt="Visa" class="h-5 w-auto">
        </div>
    
        <!-- Card Number -->
        <div class="mt-2 text-lg font-mono tracking-widest">
          ${cardnumber.replace(/(.{4})/g, '$1 ')}
        </div>
    
        <!-- Name and Expiry -->
        <div class="flex justify-between items-end mt-3 text-sm">
          <div>
            <div class="text-xs text-gray-200">Cardholder</div>
            <div contenteditable="true">${cardholder}</div>
          </div>
          <div class="text-right">
            <div class="text-xs text-gray-200">Expiry</div>
            <div contenteditable="true">${expirydate}</div>
          </div>
        </div>
    
        <!-- Billing + CVV as tooltip/hint -->
        <div class="mt-2 text-xs text-gray-200">
          Billing: <span contenteditable="true" class="text-white">${billingaddress}</span><br>
          CVV: <span contenteditable="true" class="text-white">${cvvcode}</span>
        </div>
    
      </div>
    `;
  
    
  
      paymentInfo.insertAdjacentHTML('beforeend', newCardHTML);
      closeCardModal();
  
      // Clear input fields
      document.getElementById('cardholder').value = '';
      document.getElementById('cardnumber').value = '';
      document.getElementById('expirydate').value = '';
      document.getElementById('cvvcode').value = '';
      document.getElementById('billingaddress').value = '';
  
    } else {
      alert('Please fill in all fields.');
    }
  }
  
  
    // Remove the card
  let cardToDelete = null;
  
  function removeThisCard(button) {
    cardToDelete = button.closest('.visa-card-item');
    if (cardToDelete) {
      document.getElementById('deleteConfirmModal').classList.remove('hidden');
    }
  }
  
  function confirmDeleteCard() {
    if (cardToDelete) {
      cardToDelete.remove();
      cardToDelete = null;
    }
    document.getElementById('deleteConfirmModal').classList.add('hidden');
  }
  
  function cancelDeleteCard() {
    cardToDelete = null;
    document.getElementById('deleteConfirmModal').classList.add('hidden');
  }